interface CandidLogoProps {
  size?: number;
}

export const CandidLogo = ({ size = 16 }: CandidLogoProps) => {
  return (
    <svg
      className="inline ml-1"
      height={size}
      viewBox="0 0 39 39"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Candid Health">
      <g clipRule="evenodd" fill="currentColor" fillRule="evenodd">
        <path d="m6.98872 32.1435c-3.80326-3.8033-3.80326-9.9694 0-13.7726 1.4576-1.4576 3.26208-2.3568 5.14788-2.6968l-2.96004-2.96c-1.73952.6506-3.37107 1.6753-4.77021 3.0744-5.229299 5.2293-5.229299 13.7081 0 18.9374 5.22929 5.2293 13.70805 5.2293 18.93735 0 1.3992-1.3992 2.4239-3.0307 3.0745-4.7702l-2.9597-2.9597c-.3404 1.8855-1.2392 3.6903-2.6968 5.1479-3.8032 3.8032-9.9694 3.8032-13.77262 0z" />
        <path d="m27.1502 27.0193c2.8184-.3723 5.541-1.6408 7.7066-3.8064 5.2293-5.2293 5.2293-13.70812 0-18.93741-5.2293-5.229298-13.7081-5.229299-18.9374 0-2.1656 2.1656-3.4342 4.88821-3.8065 7.70661 3.9876-.5266 8.1668.7424 11.2308 3.8064 3.0641 3.0641 4.3327 7.2429 3.8065 11.2308z" />
        <path d="m12.1366 15.6741c.3992 2.7585 1.6606 5.4165 3.7828 7.5387s4.7802 3.3836 7.5387 3.7828c.5477-3.0346-.3511-6.2791-2.6968-8.6247-2.3456-2.3457-5.5904-3.2448-8.6247-2.6968z" />
      </g>
    </svg>
  );
};
